/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(obj, key, defaultValue, undef) {
  var keys = key.split ? key.split('.') : Array.isArray(key) ? key : [key];

  for (var propIndex = 0; propIndex < keys.length; propIndex++) {
    obj = obj ? obj[keys[propIndex]] : undef;
  }

  return obj === undef ? defaultValue : obj;
}